import React, { Fragment } from 'react';
import {Header, Segment, Grid, Table, Loader, Divider, Icon, Popup, Form, Button} from 'semantic-ui-react';
import { PieChart, Pie, Tooltip, Cell, Legend } from 'recharts';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { ToastContainer } from 'react-toastify';
import { statisticColors as colors, center, legendStyle, colorss } from '../../Statistics/util';
import { fetchMarks } from '../../Lookups/util';
import { IconHeader } from '../ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class CourseStatistics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chartData: [],
            dataa: [],
            loading: true,
            studyProgramBasics: [],
            studyProgramBasicId: null,

            selectedAcademicYears: [],
            academicYears: JSON.parse(localStorage.getItem('academicYears')),
            academicYearSemesterOptions: [],
            selectedAcademicYearSemester: [],

            multiYearData: [],
            showMultiYearTable: false,
            loadingMultiYear: false
        };

        this.getData = this.getData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getSemesters = this.getSemesters.bind(this);
    }

    componentDidMount() {
        const routeState = this.props.location && this.props.location.state;
        if (routeState) {
            localStorage.setItem('courseImplementationId', routeState.courseImplementationId);
            localStorage.setItem('courseImplementationName', routeState.courseImplementationName);
            localStorage.setItem('academicYearId', routeState.academicYear);
            localStorage.setItem('semester', routeState.semester);
        }
        this.getSemesters();
        let obj = {};
        axios.post((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja')) ?
            `study-programs/basic/${localStorage.getItem('orgUnit')}`
            : 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                this.setState({ studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });
        this.getData(0);
    }

    getSemesters() {
        const academicYears = this.state.academicYears || [];

        Promise.all(
            academicYears.map(year =>
                axios.get(`semester/by-academic-year/${year.id || year.value || year.key}`)
                    .then(res =>
                        (res.data || [])
                            .filter(el =>
                                el.name &&
                                el.name.name !== 'ostalo' &&
                                el.name.name !== 'ljetna škola'
                            )
                            .map(el => ({
                                key: `${year.id || year.value || year.key}-${el.id}`,
                                value: `${year.id || year.value || year.key}-${el.id}`,
                                text: `${el.name.name.charAt(0).toUpperCase() + el.name.name.slice(1)} ${year.name || year.text}`,
                                academicYearId: year.id || year.value || year.key,
                                semesterId: el.id,
                                semesterName: el.name.name,
                                academicYearName: year.name || year.text
                            }))
                    )
            )
        )
            .then(results => {
                const academicYearSemesterOptions = results.flat();

                this.setState({
                    academicYearSemesterOptions
                });
            })
            .catch(err => {
                console.log('Failed to fetch semesters. ', err);
            });
    }

    getData(studyProgramBasicId) {
        this.setState({ loading: true });
        axios.get((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja')) ?
            `exams/course-statistics/${localStorage.getItem('academicYearId')}/${localStorage.getItem('semester')}/${localStorage.getItem('courseImplementationId')}/${localStorage.getItem('orgUnit')}/${studyProgramBasicId}`
            : `exams/course-statistics/${localStorage.getItem('academicYearId')}/${localStorage.getItem('semester')}/${localStorage.getItem('courseImplementationId')}/${studyProgramBasicId}`)
            .then(res => {
                this.setState({
                    loading: false,
                    dataa: res.data
                });
                if (res.data.length) {
                    const chartData = [
                        {
                            displayName: '5 (pet)',
                            count: res.data[0].numberOfFs
                        },
                        {
                            displayName: '6 (šest)',
                            count: res.data[0].numberOfEs
                        },
                        {
                            displayName: '7 (sedam)',
                            count: res.data[0].numberOfDs
                        },
                        {
                            displayName: '8 (osam)',
                            count: res.data[0].numberOfCs
                        },
                        {
                            displayName: '9 (devet)',
                            count: res.data[0].numberOfBs
                        },
                        {
                            displayName: '10 (deset)',
                            count: res.data[0].numberOfAs
                        },
                        {
                            displayName: 'nije ocijenjen/nije pristupio',
                            count: res.data[0].numberOfNONPs
                        }
                    ];
                    this.setState({
                        chartData
                    });
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                console.log('Failed to fetch course statistics. ', err);
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
        if (value === '') {
            this.getData(0);
        } else {
            this.getData(value);
        }
    }

    getAcademicYearName = (id) => {
        const year = (this.state.academicYears || []).find(
            y => y.value === id || y.key === id || y.id === id
        );
        return year ? (year.text || year.name) : '';
    };

    getSemesterNameById = (semesterId) => {
        const semesterOptions = this.state.academicYearSemesterOptions || [];
        const found = semesterOptions.find(
            s => Number(s.semesterId) === Number(semesterId)
        );

        if (found && found.semesterName) {
            return found.semesterName.charAt(0).toUpperCase() + found.semesterName.slice(1);
        }

        if (Number(semesterId) === 1) return 'Zimski semestar';
        if (Number(semesterId) === 2) return 'Ljetni semestar';

        return 'Semestar';
    };

    getAcademicYearSemesterLabel = (academicYearId, semesterId) => {
        const yearName = this.getAcademicYearName(academicYearId);
        const semesterName = this.getSemesterNameById(semesterId);

        const label = `${semesterName} ${yearName}`.trim();

        return label.charAt(0).toLowerCase() + label.slice(1);
    };

    handleAcademicYearsChange = (selectedValues) => {
        this.setState({ selectedAcademicYearSemester: selectedValues });
    };

    fetchMultiYearData = () => {
        const selectedValues = this.state.selectedAcademicYearSemester;
        if (!selectedValues || selectedValues.length === 0) return;

        const courseBasicId = Number(localStorage.getItem('courseBasicId'));

        this.setState({
            loadingMultiYear: true,
            multiYearData: [],
            showMultiYearTable: false
        });

        Promise.all(
            selectedValues.map(selectedValue => {
                const selectedOption = this.state.academicYearSemesterOptions.find(
                    option => option.value === selectedValue
                );

                if (!selectedOption) return Promise.resolve(null);

                return axios.get(`/course/for-employee/${selectedOption.academicYearId}/`)
                    .then(res => {
                        const courseImplementation = (res.data || []).find(ci =>
                            ci.courseBasicId === courseBasicId &&
                            ci.semesterId === selectedOption.semesterId
                        );

                        if (!courseImplementation) return null;

                        return axios.get(
                            `exams/course-statistics/${selectedOption.academicYearId}/${selectedOption.semesterId}/${courseImplementation.courseImplementationId}/0`
                        ).then(statRes => ({
                            ...statRes.data[0],
                            academicYearId: selectedOption.academicYearId,
                            semesterId: selectedOption.semesterId,
                            semesterName: selectedOption.semesterName,
                            academicYearName: selectedOption.academicYearName
                        }));
                    });
            })
        )
            .then(results => {
                this.setState({
                    multiYearData: results.filter(Boolean),
                    loadingMultiYear: false,
                    showMultiYearTable: true,
                    selectedAcademicYearSemester: []
                });
            })
            .catch(err => {
                console.log(err);
                this.setState({ loadingMultiYear: false });
            });
    };


    render() {
        const {
            dataa, chartData
        } = this.state;
        return (
            <div>
                <Header as="h1"> <FormattedMessage id="professorStatistics.statistics" /></Header>
                <Segment.Group raised style={{ backgroundColor: 'white' }}>
                    <Segment clearing>
                        <Header as="h3">
                            <Header.Content>
                                {localStorage.getItem('courseImplementationName')}
                            </Header.Content>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back" />}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader><FormattedMessage id="professorStatistics.courseName" /></Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                {/*<Form.Field>*/}
                                {/*    <Form.Dropdown*/}
                                {/*        label="Studijski program"*/}
                                {/*        clearable*/}
                                {/*        placeholder="Odaberite studijski program"*/}
                                {/*        options={this.state.studyProgramBasics}*/}
                                {/*        onChange={this.handleInputChange}*/}
                                {/*        name="studyProgramBasicId"*/}
                                {/*        value={this.state.studyProgramBasicId}*/}
                                {/*        search*/}
                                {/*        fluid*/}
                                {/*        selection*/}
                                {/*    />*/}
                                {/*</Form.Field>*/}
                                <Form.Field>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '12px' }}>
                                        <span style={{ fontSize: '14px', color: '#555' }}>
                                            <FormattedMessage id="professorInputGrades.showStatisticField" />
                                        </span>

                                                                        <span style={{ fontSize: '16px', fontWeight: 700 }}>
                                            {this.getAcademicYearSemesterLabel(
                                                Number(localStorage.getItem('academicYearId')),
                                                Number(localStorage.getItem('semester'))
                                            )}
                                        </span>
                                    </div>
                                </Form.Field>
                                <Form.Field />
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        <Grid columns="equal" centered className="stackable">
                            <Grid.Row streched>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4"><FormattedMessage id="professorStatistics.tableShow" /><br />
                                        </Header>
                                    </Divider>
                                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                                        dataa.length ? <div>
                                            <Table celled selectable compact>
                                                <Table.Header>
                                                    <Table.Row>
                                                        <Table.HeaderCell>
                                                            <FormattedMessage id="common.grade" />
                                                        </Table.HeaderCell>
                                                        <Table.HeaderCell>
                                                            <FormattedMessage id="professorInputGrades.gradedStudentsNumber" />
                                                        </Table.HeaderCell>
                                                    </Table.Row>
                                                </Table.Header>
                                                <Table.Body>
                                                    {dataa[0].numberOfFs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.five" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfFs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.six" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfEs}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.seven" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfDs}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.eight" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfCs}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.nine" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfBs}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.ten" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfAs}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    {dataa[0].numberOfNONPs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.nonp" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfNONPs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfNONPs === 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.np" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfNONPs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfNONPs === 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.na" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfNAs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfIOs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.io" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfIOs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfNZs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.nz" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfNZs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfZs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.z" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfZs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfNOs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.no" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfNOs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfUOs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.uo" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfUOs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {/* {data.map(el => */}
                                                    {/*    (<Table.Row > */}
                                                    {/*        <Table.Cell verticalAlign="middle"> */}
                                                    {/*            {el.mark} */}
                                                    {/*        </Table.Cell> */}
                                                    {/*        <Table.Cell verticalAlign="middle"> */}
                                                    {/*            {el.count} */}
                                                    {/*        </Table.Cell> */}
                                                    {/*    </Table.Row>))} */}
                                                </Table.Body>
                                                <Table.Footer>
                                                    <Table.Row>
                                                        <Table.HeaderCell>
                                                        </Table.HeaderCell>
                                                        <Table.HeaderCell>
                                                            <h4><FormattedMessage id="professorInputGrades.averageGrade" /> {dataa[0].averageGrade}</h4>
                                                        </Table.HeaderCell>

                                                    </Table.Row>
                                                </Table.Footer>
                                            </Table>
                                        </div>
                                            : <Fragment>
                                                <FormattedMessage id="professorInputGrades.noDataForAcademicYear" />
                                            </Fragment>}
                                    {/* </Segment.Group > */}
                                </Grid.Column>

                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4"><FormattedMessage id="professorStatistics.graphicShow" /><br />
                                        </Header>
                                    </Divider>
                                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                                        this.state.dataa.length ?
                                            <Fragment>
                                                <PieChart style={center} width={400} height={300}>
                                                    <Pie
                                                        data={chartData}
                                                        innerRadius={20}
                                                        outerRadius={100}
                                                        paddingAngle={5}
                                                        dataKey="count"
                                                        nameKey="displayName"
                                                    >
                                                        {
                                                            chartData.map((entry, index) => <Cell fill={colors[index % colors.length]} />)
                                                        }
                                                    </Pie>
                                                    <Legend iconType="circle" iconSize={15} width={160} height={140} layout="vertical" align="left" verticalAlign="bottom" wrapperStyle={legendStyle} />

                                                    <Tooltip />
                                                </PieChart>
                                            </Fragment> :
                                            <Fragment>
                                                <FormattedMessage id="professorInputGrades.noDataForAcademicYear" />
                                            </Fragment>}

                                    {/* </Segment.Group> */}
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row streched style={{ marginTop: '30px' }}>
                                <Grid.Column width={16}>
                                    <Divider horizontal style={{ marginBottom: '16px' }}>
                                        <Header as="h4">
                                            <FormattedMessage id="professorInputGrades.compareStatistics" />
                                        </Header>
                                    </Divider>

                                    <br/>
                                    <Form style={{ marginBottom: '8px' }}>
                                        <Form.Group style={{ width: '50%', marginBottom: 0 }}>
                                            <Form.Field style={{ flex: 1, marginRight: '10px', marginBottom: 0 }}>
                                                <Form.Dropdown
                                                    label={<b style={{ display: 'block', marginBottom: '8px' }}>
                                                        <FormattedMessage id="professorInputGrades.addMoreStatistic" />
                                                    </b>}
                                                    clearable
                                                    placeholder="Odaberite semestre"
                                                    name="academicYearSemester"
                                                    options={this.state.academicYearSemesterOptions.filter(
                                                        el => !(el.academicYearId === Number(localStorage.getItem('academicYearId')) &&
                                                            el.semesterId === Number(localStorage.getItem('semester')))
                                                    )}
                                                    value={this.state.selectedAcademicYearSemester}
                                                    onChange={(e, { value }) => this.handleAcademicYearsChange(value)}
                                                    search
                                                    selection
                                                    multiple
                                                    fluid
                                                />
                                            </Form.Field>

                                            <Form.Field style={{ flex: '0 0 250px', display: 'flex', alignItems: 'flex-end', marginBottom: 0 }}>
                                                <Button
                                                    color="blue"
                                                    onClick={this.fetchMultiYearData}
                                                    icon
                                                    labelPosition="left"
                                                    style={{ width: '100%' }}
                                                >
                                                    <Icon className="chart bar" />
                                                    <FormattedMessage id="professorInputGrades.showStatistic" />
                                                </Button>
                                            </Form.Field>
                                        </Form.Group>
                                    </Form>
                                </Grid.Column>
                            </Grid.Row>

                            <Grid.Row stretched style={{ paddingTop: 0 }}>
                                <Grid.Column>

                                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                                        dataa.length ? <Fragment>
                                                <Header as="h6" style={{ color: '#2185d0', marginBottom: '0', marginTop: '15px' }}>
                                                    <FormattedMessage id="professorInputGrades.statisticNote" />
                                                </Header>
                                                <Table size="small" celled selectable compact>
                                                    <Table.Header>
                                                        <Table.Row>
                                                            <Table.HeaderCell>Akademska godina</Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                <FormattedMessage id="professorStatistics.numberOfStudentsOnCourse" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                <FormattedMessage id="professorStatistics.numberOfDistinctStudentGradedActivities" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                <FormattedMessage id="professorStatistics.numberOfExamRegistrations" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                <FormattedMessage id="professorStatistics.numberOfDistinctStudentsWhoAccessedExam" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                <FormattedMessage id="professorStatistics.numberOfStudentsWhoAccessedExam" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                <FormattedMessage id="professorStatistics.numberOfStudentsWhoPassed" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                <FormattedMessage id="professorStatistics.averagePassedStudentsOnCourse" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                <FormattedMessage id="professorStatistics.averagePassedDistinctStudentGradedActivities" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                <FormattedMessage id="professorStatistics.averagePassed" />
                                                            </Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>
                                                    <Table.Body>
                                                        {/* Prvobitni podaci */}
                                                        {dataa.map((el, index) => (
                                                            <Table.Row key={'original-' + index}>
                                                                <Table.Cell>
                                                                    <strong>
                                                                        {this.getAcademicYearSemesterLabel(
                                                                            Number(localStorage.getItem('academicYearId')),
                                                                            Number(localStorage.getItem('semester'))
                                                                        )}
                                                                    </strong>
                                                                </Table.Cell>
                                                                <Table.Cell>{el.numberOfStudentsOnCourse}</Table.Cell>
                                                                <Table.Cell>{el.numberOfDistinctStudentGradedActivities}</Table.Cell>
                                                                <Table.Cell>{el.numberOfExamRegistrations}</Table.Cell>
                                                                <Table.Cell>{el.numberOfDistinctStudentsWhoAccessedExam}</Table.Cell>
                                                                <Table.Cell>{el.numberOfStudentsWhoAccessedExam}</Table.Cell>
                                                                <Table.Cell>{el.numberOfStudentsWhoPassed}</Table.Cell>
                                                                <Table.Cell><strong>{el.averagePassedStudentsOnCourse} %</strong></Table.Cell>
                                                                <Table.Cell><strong>{el.averagePassedDistinctStudentGradedActivities} %</strong></Table.Cell>
                                                                <Table.Cell><strong>{el.averagePassed} %</strong></Table.Cell>
                                                            </Table.Row>
                                                        ))}

                                                        {this.state.loadingMultiYear ? (
                                                            <Table.Row>
                                                                <Table.Cell colSpan={10} textAlign="center">
                                                                    <Loader active inline="centered" />
                                                                </Table.Cell>
                                                            </Table.Row>
                                                        ) : (
                                                            this.state.multiYearData.length > 0 &&
                                                            this.state.multiYearData.map((el, index) => (
                                                                <Table.Row key={'multi-' + index} style={{ backgroundColor: '#f9f9f9' }}>
                                                                    <Table.Cell>
                                                                        <strong>{this.getAcademicYearSemesterLabel(el.academicYearId, el.semesterId)}</strong>
                                                                    </Table.Cell>
                                                                    <Table.Cell>{el.numberOfStudentsOnCourse}</Table.Cell>
                                                                    <Table.Cell>{el.numberOfDistinctStudentGradedActivities}</Table.Cell>
                                                                    <Table.Cell>{el.numberOfExamRegistrations}</Table.Cell>
                                                                    <Table.Cell>{el.numberOfDistinctStudentsWhoAccessedExam}</Table.Cell>
                                                                    <Table.Cell>{el.numberOfStudentsWhoAccessedExam}</Table.Cell>
                                                                    <Table.Cell>{el.numberOfStudentsWhoPassed}</Table.Cell>
                                                                    <Table.Cell><strong>{el.averagePassedStudentsOnCourse} %</strong></Table.Cell>
                                                                    <Table.Cell><strong>{el.averagePassedDistinctStudentGradedActivities} %</strong></Table.Cell>
                                                                    <Table.Cell><strong>{el.averagePassed} %</strong></Table.Cell>
                                                                </Table.Row>
                                                            ))
                                                        )}
                                                    </Table.Body>
                                                </Table>
                                        </Fragment>
                                            : ''}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Segment>
                </Segment.Group>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/Courses/CourseStatistics.js